import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from './LanguageContext';
import './Payment.css';
import AMEXLogo from '../logos de securite/AMEX.png';
import MarocPayLogo from '../logos de securite/MarocPay.png';
import securrCodeLogo from '../logos de securite/secure_code_logo.png';
import CMIlogo from '../logos de securite/logo_cmi.png';
import InVerifedByVisa from '../logos de securite/tn_verified_by_visa.png';
import UnionPay from '../logos de securite/unionpay.png';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div>
            <h3 className="footer-title">FECAnalytics</h3>
            <p>{t('footer.title')}</p>
          </div>

          <div>
            <h3 className="footer-title">{t('footer.quickLinks')}</h3>
            <ul className="footer-links">
              <li><a href="#home">{t('links.home')}</a></li>
              <li><a href="#features">{t('links.features')}</a></li>
              <li><a href="#about">{t('links.about')}</a></li>
              <li><a href="#pricing">{t('links.pricing')}</a></li>
              <li><Link to="/faq">{t('links.faq')}</Link></li>
              {/* <li><Link to="/simulateur">{t('links.simulator')}</Link></li> */}
              {/* <li><Link to="/optimisation">{t('links.optimizer')}</Link></li> */}
            </ul>
          </div>

          <div>
            <h3 className="footer-title">{t('footer.legal')}</h3>
            <ul className="footer-links">
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/docs/mentions-legales.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('footer.mentions')}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/docs/Politique_de_confidentialite_FEC_Analytics.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('footer.privacy')}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/docs/Conditions_d_utilisation_FEC_Analytics.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('footer.terms')}
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/docs/Conditions_generales_de_vente_FEC_Analytics.html`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('footer.cgv')}
                </a>
              </li>
              <li>
                <Link to="/documentation">{t('footer.guide')}</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="footer-title">{t('footer.contact')}</h3>
            <ul className="footer-links">
              <li>
                <a href={`mailto:${t('footer.contact.emailValue')}`}>
                  {t('contact.email')}: {t('footer.contact.emailValue')}
                </a>
              </li>
              <li>
                <a href={t('footer.contact.phoneHref')}>
                  {t('contact.phone')}: {t('footer.contact.phoneValue')}
                </a>
              </li>
              {/* <li>
                <a href="/#contact">
                  {t('contact.address')}: {t('footer.contact.addressValue')}
                </a>
              </li> */}
              <li>
                <Link to="/#contact">{t('footer.contact.link')}</Link>
              </li>
            </ul>
          </div>
          {/* Newsletter supprimee a la demande */}
        </div>
        <section
          className="logos"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            flexWrap: 'wrap',
            flexDirection: 'wrap',
            borderRadius: 'var(--border-radius, 16px)',
            backgroundColor: '#fff',
            padding: '10px',
          }}
        >
          <img src={CMIlogo} alt="CMI" style={{ width: '64px', aspectRatio: 1, objectFit: 'contain' }} />
          <img src={MarocPayLogo} alt="MarocPay" style={{ width: '64px', aspectRatio: 1, objectFit: 'contain' }} />
          <img src={InVerifedByVisa} alt="InVerifedByVisa" style={{ width: '64px', aspectRatio: 1, objectFit: 'contain' }} />
          <img src={UnionPay} alt="UnionPay" style={{ width: '64px', aspectRatio: 1, objectFit: 'contain' }} />
          <img src={securrCodeLogo} alt="securrCode" style={{ width: '64px', aspectRatio: 1, objectFit: 'contain' }} />
          <img src={AMEXLogo} alt="AMEX" style={{ width: '64px', aspectRatio: 1, objectFit: 'contain' }} />
        </section>
        <div className="footer-bottom">
          <p>&copy; 2025 FECAnalytics. {t('footer.copy')}</p>
        </div>
      </div>
    </footer>
  );
}
